// Meta Pixel utility
// Pixel ID: 988100866966932

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

const PIXEL_ID = '988100866966932'

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return // already initialized

  // Create the fbq stub
  const w = window as any
  const fbq: any = function () {
    // eslint-disable-next-line prefer-rest-params
    fbq.callMethod
      ? // eslint-disable-next-line prefer-rest-params
        fbq.callMethod.apply(fbq, arguments)
      : // eslint-disable-next-line prefer-rest-params
        fbq.queue.push(arguments)
  }
  w.fbq = fbq
  if (!w._fbq) w._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  // Inject the script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  // Fire init + PageView
  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')
}

export function trackAddToCart(params?: Record<string, any>): void {
  if (typeof window === 'undefined') return
  const w = window as any
  if (!w.fbq) return
  w.fbq('track', 'AddToCart', params)
}

export {}
